var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddPeoplei = function SvgAddPeoplei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1597"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    "data-name": "Group 5874"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.814 13.486a3.9 3.9 0 0 0 1.22-2.531 3 3 0 0 0 .01-.292 2 2 0 0 0-.02-.333h-.5a1.92 1.92 0 0 1-1.21-.423 2.4 2.4 0 0 1 .13.756 2.234 2.234 0 1 1-.82-1.725 1.8 1.8 0 0 1-.1-.625 2.04 2.04 0 0 1 .33-1.119 3.7 3.7 0 0 0-1.63-.373 3.846 3.846 0 0 0-2.59 6.665 5.39 5.39 0 0 0-2.6 3.579 1.614 1.614 0 0 0 1.57 1.936h7.24a1.614 1.614 0 0 0 1.57-1.936 5.39 5.39 0 0 0-2.6-3.579m-6.21 3.9a3.69 3.69 0 0 1 7.24 0z",
    "data-name": "Path 4835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.524 7.501h-1.7v-1.7a.8.8 0 0 0-1.6 0v1.7h-1.7a.8.8 0 1 0 0 1.6h1.7v1.7a.8.8 0 0 0 1.6 0v-1.7h1.7a.8.8 0 0 0 0-1.6",
    "data-name": "Path 4836"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddPeoplei);
export default ForwardRef;